(function($, duo, undefined) {

	"use strict";

	// classes:
	const SUBNAV_CONTAINER_CLASS = 'js-subnav-container';
	const SUBNAV_BUTTON_CLASS = 'js-subnav-button';
	const SUBNAV_CONTENTWRAPPER_CLASS = 'js-subnav-contentwrapper';

	/**
	 * @class Subnavigation
	 */
	class Subnavigation {

		/**
		 * Creates an instance of Subnavigation
		 * @param {string} navSelector css selector for the Subnavigation element
		 * @param {string} toggleText text to display on the toggle button
		 * @param {string} openClass css class that goes on the subnavigation item when it is open
		 */
		constructor({navSelector = '.subnav', toggleText = 'Select', openClass = 'js-subnav-item-opened'} = {}) {
			this.navSelector = navSelector;
			this.element = $(navSelector);
			this.toggleText = toggleText;
			this.openClass = openClass;

			// setup:
			this.setup();
		} /* constructor */

		/**
		 * Setup the Subnavigation
		 */
		setup() {
			// setup markup:
			this._setupMarkup();
			// setup event handlers:
			this._setEventHandlers();

			// add js-processed class to the container:
			$(this.containerSelector).addClass('js-subnavigation-processed');
		} /* setup */

		/**
		 * Setup the markup
		 */
		_setupMarkup() {
			const subnavigation = this;

			// wrap the "element" inside a collapsible div, and add
			// a toggle-button;

			// -> create a unique ID:
			const id = 'subnavigation-' + this.element.index();

			// -> create a container:
			const $toggleContainer = $(`<div class="${SUBNAV_CONTAINER_CLASS}"></div>`);
			// -> create a content-container:
			const $contentContainer = $(`<div id="${id}" aria-hidden="true" class="${SUBNAV_CONTENTWRAPPER_CLASS}" data-role="subnav-content"></div>`);
			// -> add the containers to the page:
			$toggleContainer.append($contentContainer);
			this.element.wrapInner($toggleContainer);

			// -> add a toggle button:
			const $toggleButton = $(`<button aria-expanded="false" aria-controls="${id}" class="${SUBNAV_BUTTON_CLASS}" data-role="subnav-button">${Drupal.t(subnavigation.toggleText)}</button>`);
			this.element.find(`.${SUBNAV_CONTAINER_CLASS}`).prepend($toggleButton);
		} /* _setupMarkup */

		_setEventHandlers() {
			const subnavigation = this;

			/* toggle button click */
			/* ******************* */

			$(document).on('click', `.${SUBNAV_BUTTON_CLASS}`, function(event) {
				const $subnavButton = $(this);

				// get current subnav item + the toggle-item:
				const $subnavItem = $subnavButton.parents(`.${SUBNAV_CONTAINER_CLASS}`);
				let $contentElement;
				if($subnavItem.length > 0) {
					$contentElement = $subnavItem.find(`.${SUBNAV_CONTENTWRAPPER_CLASS}`);
				}

				if($subnavItem.length > 0 && $contentElement.length > 0) {

					// get the current state:
					const state = $subnavButton.attr('aria-expanded') === 'false' ? true : false;

					// -> set the expanded state on the button:
					$subnavButton.attr('aria-expanded', state);

					// -> set aria-hidden state on the content:
					$contentElement.attr('aria-hidden', !state);

					// -> set open-class on the container-item:
					if(state) {
						$subnavItem.addClass(subnavigation.openClass);
					} else {
						$subnavItem.removeClass(subnavigation.openClass);
					}

				}

			});
		} /* _setEventHandlers */

		/**
		 * Setup the markup
		 */
		setActivePageLinks() {

			// find all links inside the Subnavigation and
			// add a class "js-active" to the links that point
			// to the current page

			// -> current page url:
			const currentPathName = window.location.pathname;

			// -> find links:
			let $links = this.element.find('a[href]');
			$links.each(function(index, element) {
				const $link = $(element);
				if($link.attr("href") === currentPathName) {
					$link.addClass('js-active');
				}
			});
		} /* setActivePageLinks */

	} /* Subnavigation */

	duo.Subnavigation = Subnavigation;

})(jQuery, window.duo = window.duo || {});
